import React from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { X, Building2, Mail, MapPin } from 'lucide-react';

const ENTITIES = [
  {
    title: 'ApexForge Holding.inc',
    tag: 'SEYCHELLES ENTITY',
    detail: 'Incorporated in the Republic of Seychelles with registration number 191321.',
    address: 'Suite 23, 3rd Floor, Eden Plaza, Eden Island, Mahe, Republic of Seychelles',
  },
  {
    title: 'ApexForge (Trading Name)',
    tag: 'SOUTH AFRICA · FSCA REGULATED',
    detail: 'Trading name of ApexForge Holding.inc, an authorised Financial Service Provider (“FSP”) registered and regulated by the Financial Sector Conduct Authority (“FSCA”) of South Africa.',
    address: '22 Cavendish Sp, Claremont, Cape Town, Western Cape 7708, South Africa.',
  },
  {
    title: 'ApexForge Holding.inc',
    tag: 'EUROPEAN ENTITY · REG HE 549882',
    detail: 'Incorporated in Cyprus with Company Registration Number HE 549882.',
    address: 'Souliou 22, Strovolos, 2026, Nicosia, Cyprus.',
  },
];

export default function ContactModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--panel)] border-[var(--border)] text-[var(--text)] max-w-2xl p-0 gap-0 [&>button]:hidden max-h-[92vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-[var(--border)]">
          <div className="flex items-center gap-2.5">
            <Building2 size={18} className="text-[var(--orange)]" />
            <h3 className="font-display font-semibold text-white text-[16px]">Contact & Registered Offices</h3>
          </div>
          <button onClick={onClose} className="text-[var(--muted)] hover:text-white p-1"><X size={18} /></button>
        </div>

        <div className="p-6 space-y-4">
          {ENTITIES.map((e, i) => (
            <div key={i} className="rounded-xl bg-[var(--bg)] border border-[var(--border)] p-5">
              <div className="flex items-center gap-2 flex-wrap">
                <h4 className="font-display font-semibold text-[15px] text-white">{e.title}</h4>
                <span className="text-[9px] font-mono px-2 py-0.5 rounded bg-[#2a1a0e] text-[var(--orange)] border border-[#4a2f14]">{e.tag}</span>
              </div>
              <p className="text-[12.5px] text-[var(--muted)] mt-2 leading-relaxed">{e.detail}</p>
              <div className="flex items-start gap-2 mt-3 text-[12.5px] text-[var(--text)]">
                <MapPin size={15} className="text-[var(--orange)] mt-0.5 shrink-0" />
                <span><span className="text-[var(--muted-2)] font-mono text-[10px] tracking-widest">REGISTERED ADDRESS </span><br />{e.address}</span>
              </div>
            </div>
          ))}

          <div className="rounded-xl bg-[#1a1030] border border-[#3f2a5a] p-5 flex items-center justify-between flex-wrap gap-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#2a1a3a] border border-[#3f2a5a] flex items-center justify-center">
                <Mail size={18} className="text-[#c084fc]" />
              </div>
              <div>
                <div className="text-[9px] font-mono tracking-widest text-[var(--muted-2)]">GENERAL & SUPPORT ENQUIRIES</div>
                <a href="mailto:help@apexforge.io" className="text-[15px] font-semibold text-white hover:text-[var(--orange)] transition-colors">help@apexforge.io</a>
              </div>
            </div>
            <a href="mailto:help@apexforge.io" className="px-4 py-2.5 rounded-lg bg-[var(--orange)] text-white text-[13px] font-semibold hover:bg-[var(--orange-bright)] transition-colors">Email Us</a>
          </div>

          <p className="text-center text-[10px] font-mono text-[var(--muted-2)]">ALL DATA SIMULATED FOR DEMONSTRATION · NOT AN OFFER TO BUY OR SELL SECURITIES</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
